import { SkipOrArgs } from '@common/types/queryState';
import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import { MediaObjectQuality, MediaObjectType } from '../types/media';
import { useClipTracks, UseClipTracksArgs } from './useClipTracks';
import { useSelectedClip } from './useSelectedClipSelectors';

export const useSelectedClipTracks = (
    type: MediaObjectType,
    quality: MediaObjectQuality,
) => {
    const { selectedClip } = useSelectedClip();
    const queryArgs: SkipOrArgs<UseClipTracksArgs> = useMemo(() => {
        if (
            !selectedClip ||
            !selectedClip.mediaObjectId ||
            !selectedClip.mediaIdentifiers?.[type]?.[quality]?.id
        )
            return skipToken;

        return {
            mediaObjectId: selectedClip.mediaObjectId,
            moiId: selectedClip.mediaIdentifiers[type][quality].id,
        };
    }, [quality, selectedClip, type]);

    return useClipTracks(queryArgs);
};
